































































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ECheckoutStep } from '@/helpers/enums';

import PartnerMixin from '@/shared/mixins/PartnerMixin';

const AppModule = namespace('App');
const CustomerModule = namespace('App/Customer');
const CheckoutModule = namespace('App/Checkout');

@Component
export default class Header extends Mixins(PartnerMixin) {
  @CustomerModule.Getter
  private isLogged: boolean;

  @CustomerModule.Getter
  private firstName: string;

  @CustomerModule.Action
  private logout: Function;

  @AppModule.State(state => state.step.currentStep)
  private stepsCurrentStep: number;

  @CheckoutModule.Getter
  private isRenewal: boolean;

  private get screenSize(): string {
    return this.$vuetify.breakpoint.name;
  }

  private get checkoutSteps(): any {
    return ECheckoutStep;
  }

  private doLogout() {
    this.logout();
  }
}
